/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
window.addEventListener("load", async () => {
  const baseName = "wp-block-gvv-program";
  const onlyPostMatches = document
    .querySelector(`.${baseName}`)
    .classList.contains("gvv-program--only-post-matches");
  const postIdClass = Array.from(document.body.classList).find((c) =>
    c.startsWith("postid-")
  );

  const postId = postIdClass
    ? parseInt(postIdClass.replace("postid-", ""), 10)
    : null;

  const fetchMatches = async (page) => {
    const response = await fetch(
      `${gvvAjax.ajax_url}?action=get_all_matches_paginated&posts_per_page=7&page=${page}&only_post_matches=${onlyPostMatches}&post_id=${postId}`
    );
    if (response.status !== 200) {
      console.error("Error fetching matches:", response.statusText);
      return;
    }
    return await response.json();
  };

  const getRenderedMatches = (matches) => {
    return matches.map((match) => {
      return `<div class="${baseName}__content-item">
          <div class="${baseName}__content-item__date">${new Date(
            match.start_date
          ).toLocaleString("nl-NL", {
            dateStyle: "full",
            timeStyle: "short",
          })}</div>
          <div class="${baseName}__content-item__title">
              <div class="${baseName}__content-item__title__hometeam">
                  <div
                      class="${baseName}__content-item__title__logo-placeholder"
                      style="background-image: url(${match.home_team_logo})"
                  ></div>
                  ${match.home_team_name}
              </div>
              <div class="${baseName}__content-item__title__awayteam">
                  <div
                      class="${baseName}__content-item__title__logo-placeholder"
                      style="background-image: url(${match.away_team_logo})"
                  ></div>
                  ${match.away_team_name}
              </div>
          </div>
          <div class="${baseName}__content-item__location">
              ${match.accommodation} ${match.city} (${match.field})
          </div>
        </div>`;
    });
  };

  const renderMatches = (matches) => {
    const content = document.querySelectorAll(`.${baseName}__content`);
    content.forEach((el) => {
      if (matches.length === 0) {
        el.innerHTML = `<p class="${baseName}__no-matches">Geen aankomende wedstrijden</p>`;
      } else {
        el.innerHTML = getRenderedMatches(matches).join("");
      }
    });
  };

  let {
    data: { matches, pagination },
  } = await fetchMatches(1);
  if (pagination.total_pages === 1) {
    document
      .querySelectorAll(`.${baseName}__toprow__pagination`)
      .forEach((el) => {
        el.classList.add("inactive");
      });
  }
  renderMatches(matches);

  const getNextPage = async () => {
    if (pagination.current_page >= pagination.total_pages) {
      console.log("No more pages");
      return;
    }
    const {
      data: { matches, pagination: newPagination },
    } = await fetchMatches(pagination.current_page + 1);
    renderMatches(matches);
    pagination = newPagination;
    if (newPagination.current_page > 1) {
      document
        .querySelectorAll(`.${baseName}__toprow__pagination__prev`)
        .forEach((el) => {
          el.classList.remove("inactive");
        });
    }
    if (newPagination.current_page === newPagination.total_pages) {
      document
        .querySelectorAll(`.${baseName}__toprow__pagination__next`)
        .forEach((el) => {
          el.classList.add("inactive");
        });
    }
  };

  const getPrevPage = async () => {
    if (pagination.current_page <= 1) {
      console.log("No previous pages");
      return;
    }
    const {
      data: { matches, pagination: newPagination },
    } = await fetchMatches(pagination.current_page - 1);
    renderMatches(matches);
    pagination = newPagination;
    if (newPagination.current_page === 1) {
      document
        .querySelectorAll(`.${baseName}__toprow__pagination__prev`)
        .forEach((el) => {
          el.classList.add("inactive");
        });
    }
    if (newPagination.current_page < newPagination.total_pages) {
      document
        .querySelectorAll(`.${baseName}__toprow__pagination__next`)
        .forEach((el) => {
          el.classList.remove("inactive");
        });
    }
  };

  const findUp = (el, className) => {
    while (el && !el.classList.contains(className)) {
      el = el.parentElement;
    }
    return el;
  };

  window.addEventListener("click", (e) => {
    if (findUp(e.target, `${baseName}__toprow__pagination__next`) !== null) {
      e.preventDefault();
      getNextPage(pagination);
    }
    if (findUp(e.target, `${baseName}__toprow__pagination__prev`) !== null) {
      e.preventDefault();
      getPrevPage(pagination);
    }
  });
});
/* eslint-enable no-console */
